// =======================
// CONSTANTS: Agent
// =======================
export enum AgentStatus {
  TRAINING = "TRAINING",
  ERROR = "ERROR",
  READY = "READY",
}

export enum AUTONOMOUS_AGENT_STATUS {
  SCHEDULING = "SCHEDULING",
  IDLE = "IDLE",
  API_TRIGGER = "API_TRIGGER",
}

export enum CREATE_AGENT_CATEGORIES {
  SPECIALIST = "SPECIALIST",
  ORCHESTRATOR = "ORCHESTRATOR",
  FUNCTIONAL = "FUNCTIONAL",
}
export enum FUNCTIONAL_AGENT_TYPE {
  AUTONOMOUS = "AUTONOMOUS",
}

enum BASE_AGENT_TYPES {
  SPECIALIST = "SPECIALIST",
  ORCHESTRATOR = "ORCHESTRATOR",
}

export enum AGENT_RUN_STATUS {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

// AGENT_TYPES: All actual agent types in the system (includes base types + all functional agent types)
// This is used for checking/displaying agent types throughout the application
// Spreads from BASE_AGENT_TYPES and FUNCTIONAL_AGENT_TYPE to automatically include all functional types
export const AGENT_TYPES = {
  ...BASE_AGENT_TYPES,
  ...FUNCTIONAL_AGENT_TYPE,
} as const;

// Type helper for AGENT_TYPES values
export type AgentTypeValue = (typeof AGENT_TYPES)[keyof typeof AGENT_TYPES];

export const FUNCTIONAL_AGENT_TYPE_OPTIONS = [
  {
    labelKey: "agents.functionalAgentTypes.autonomous",
    value: FUNCTIONAL_AGENT_TYPE.AUTONOMOUS,
  },
] as const;

export const CREATE_AGENT_CATEGORIES_OPTIONS = [
  {
    labelKey: "agents.agentTypes.specialist",
    value: CREATE_AGENT_CATEGORIES.SPECIALIST,
  },
  {
    labelKey: "agents.agentTypes.orchestrator",
    value: CREATE_AGENT_CATEGORIES.ORCHESTRATOR,
  },
  {
    labelKey: "agents.agentTypes.functional",
    value: CREATE_AGENT_CATEGORIES.FUNCTIONAL,
  },
] as const;

// AGENT_TYPES_OPTIONS: Options for filtering/displaying actual agent types
// This includes all actual agent types (SPECIALIST, ORCHESTRATOR, AUTONOMOUS, etc.)
// Used for filtering agents by their actual type, not creation category
export const AGENT_TYPES_OPTIONS = [
  { labelKey: "agents.agentTypes.specialist", value: AGENT_TYPES.SPECIALIST },
  {
    labelKey: "agents.agentTypes.orchestrator",
    value: AGENT_TYPES.ORCHESTRATOR,
  },
  ...FUNCTIONAL_AGENT_TYPE_OPTIONS.map((option) => ({
    labelKey: option.labelKey,
    value: option.value,
  })),
] as const;
